import React from 'react';
import { FormInput, FormSelect, Option, ReadOnly } from 'lqx-react';
import { Flex } from 'lqx-react/src';
import { Linked } from '@type-r/models';
import { useLinked, useModel } from '@type-r/react';
import AddCircle from '@material-ui/icons/AddCircle';
import DeleteForever from '@material-ui/icons/DeleteForever';
import { IconButton, makeStyles } from '@material-ui/core';
import { EmailAddressModel } from 'api';

export const MultiEmailInput = ({ $emails, label = 'Email Address' }: { $emails: Linked<string[]>, label?: string }) => {
    return (<>
        <AddEmailsInput $emails={$emails} label={label}/>
        {
            $emails.map(($email) => {
            return <EmailRow $email={$email}/>
            })
        }
    </>)
};

export const MultiEmailSelect = ({ $emails, emailOptions }: { $emails: Linked<string[]>, emailOptions: string[] }) => {
    return (<>
        <AddEmailsSelect $emails={$emails} emailOptions={emailOptions}/>
        {
            $emails.map(($email) => {
            return <EmailRow key={$email.value} $email={$email}/>
            })
        }
    </>)
};

const AddEmailsInput = ({ $emails, label = 'Email Address' }: { $emails: Linked<string[]>, label?: string }) => {
    const $value = useModel(EmailAddressModel);
    const classes = buttonStyles();
    const readOnly = React.useContext( ReadOnly );

    const addItem = () => { 
        $emails.push($value.email); 
        $value.$.email.set(''); 
    }

    return (<Flex row className={classes.container}>
        <FormInput label={label} $value={$value.$.email} />
        <IconButton aria-label="Add" onClick = { addItem } className={ classes.addIcon } disabled={!$value.email || !$value.isValid() || readOnly}>
            <AddCircle fontSize="large"/>
        </IconButton>
    </Flex>);
};

const AddEmailsSelect = ({ $emails, emailOptions }: { $emails: Linked<string[]>, emailOptions: string[] }) => {
    const $selectedEmail = useLinked( '' );    
    const classes = buttonStyles();
    
    function addEmail() {
        $emails.push($selectedEmail.value); 
        $selectedEmail.set('');
    }
    
    return (<Flex row className={classes.container}>
        <FormSelect $value={$selectedEmail} label="Email Address" >
            { emailOptions.filter(o => $emails.value.indexOf(o) < 0).map(o => <Option key={o} value={ o }>{ o }</Option>) }
        </FormSelect>
        <IconButton aria-label="Add" onClick = { () => {addEmail()} } className={ classes.addIcon } disabled={!$selectedEmail.value}>
            <AddCircle fontSize="large"/>
        </IconButton>
        <Flex grow/>
    </Flex>);
};

const EmailRow = ({ $email }) => {
    const classes = buttonStyles();
    const readOnly = React.useContext( ReadOnly );
    
    return (
        <div>
            <span>{$email.value}</span>
            <IconButton aria-label="Remove" onClick={ () => $email.remove() } className={ classes.removeIcon } disabled={readOnly} >
                <DeleteForever fontSize="large"/>
            </IconButton>
        </div>        
    );
};

const styleBase = {
    actionButton: {
        height:30
    }
};

const buttonStyles = makeStyles({    
    addIcon: {
        ...styleBase.actionButton,
        color:"green"
    },
    removeIcon: {
        ...styleBase.actionButton,
        color:"red"
    },
    container: {
        alignItems:"flex-start"
    }
})